import { StyleSheet } from 'react-native';

import { ActionButtonVariants } from 'components/action-button';
import { BottomSheet } from 'components/bottom-sheet';
import { Box, Typography } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { layout, spacing } from 'styles/constants';

import { StyledActionButton } from './styles';

interface NonTraditionalStoreDialogDrawerProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  accessInstructions: string;
}

export const NonTraditionalStoreDialogDrawer = ({
  isOpen,
  onConfirm,
  onCancel,
  accessInstructions,
}: NonTraditionalStoreDialogDrawerProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <BottomSheet
      onClose={onCancel}
      isOpen={isOpen}
      onOpenEventMessage="Open Non Traditional Store Drawer"
    >
      <Box style={styles.drawerContainer}>
        <Typography style={styles.drawerTitle} variant="headerThree" textAlign="center">
          {t('nonTraditionalStoreDrawerHeader')}
        </Typography>
        <Typography style={styles.drawerBody} textAlign="center">
          {accessInstructions}
        </Typography>
        <Box style={isDesktop && styles.buttonsContainerDesktop}>
          <StyledActionButton onPress={onConfirm}>{t('selectAnyways')}</StyledActionButton>
          <StyledActionButton onPress={onCancel} variant={ActionButtonVariants.OUTLINE}>
            {t('chooseAnotherLocation')}
          </StyledActionButton>
        </Box>
      </Box>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  buttonsContainerDesktop: {
    paddingHorizontal: layout['1/3'],
  },
  drawerContainer: {
    marginTop: spacing.$9,
    paddingHorizontal: spacing.$4,
    width: layout.full,
  },
  drawerBody: {
    marginBottom: spacing.$4,
  },
  drawerTitle: {
    margin: 0,
  },
});
